<script lang="ts">
  import { locale, _ as t } from "svelte-i18n";
  import ActivityInfoBar from "./ActivityInfoBar.svelte";
  import type { ActivityDetail } from "../lib/restful";
  import rulesImgSc from "../assets/images/rules.png";
  import rulesImgTc from "../assets/images/rules_tc.png";

  interface Props {
    bannerSrc?: string | null;
    activityData?: ActivityDetail | null;
    onRulesClick?: () => void;
  }

  let {
    bannerSrc = null,
    activityData = null,
    onRulesClick = () => {},
  }: Props = $props();

  let rulesImg = $derived($locale === "zh-cn" ? rulesImgSc : rulesImgTc);
</script>

<section
  class="relative bg-[linear-gradient(180deg,#1A237E_0%,#283593_100%)]"
  style={bannerSrc ? "" : "min-height: 56vw;"}
>
  {#if bannerSrc}
    <img class="block h-auto w-full banner-offset" src={bannerSrc} alt="" />
  {/if}
  <button
    class="absolute right-0 z-[3] border-0 bg-transparent p-0 cursor-pointer"
    style="top: 50%;"
    onclick={onRulesClick}
  >
    <img src={rulesImg} alt={$t("activity_rules")} class="w-[30px]" />
  </button>

  <div class="absolute left-0 right-0 z-[3]" style="bottom: 4.5%;">
    <ActivityInfoBar {activityData} />
  </div>
</section>
